// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["CAMPAIGN_STATUS_UNSPECIFIED"] = "CAMPAIGN_STATUS_UNSPECIFIED";
    CampaignStatus["CAMPAIGN_STATUS_ACTIVE"] = "CAMPAIGN_STATUS_ACTIVE";
    CampaignStatus["CAMPAIGN_STATUS_EXPIRED"] = "CAMPAIGN_STATUS_EXPIRED";
})(CampaignStatus || (CampaignStatus = {}));
export var CampaignStatus_index;
(function (CampaignStatus_index) {
    CampaignStatus_index[CampaignStatus_index["CAMPAIGN_STATUS_UNSPECIFIED"] = 0] = "CAMPAIGN_STATUS_UNSPECIFIED";
    CampaignStatus_index[CampaignStatus_index["CAMPAIGN_STATUS_ACTIVE"] = 1] = "CAMPAIGN_STATUS_ACTIVE";
    CampaignStatus_index[CampaignStatus_index["CAMPAIGN_STATUS_EXPIRED"] = 2] = "CAMPAIGN_STATUS_EXPIRED";
})(CampaignStatus_index || (CampaignStatus_index = {}));
export var CampaignSharingStatus;
(function (CampaignSharingStatus) {
    CampaignSharingStatus["CAMPAIGN_SHARING_STATUS_UNSPECIFIED"] = "CAMPAIGN_SHARING_STATUS_UNSPECIFIED";
    CampaignSharingStatus["CAMPAIGN_SHARING_STATUS_ACCEPTED"] = "CAMPAIGN_SHARING_STATUS_ACCEPTED";
    CampaignSharingStatus["CAMPAIGN_SHARING_STATUS_DECLINED"] = "CAMPAIGN_SHARING_STATUS_DECLINED";
    CampaignSharingStatus["CAMPAIGN_SHARING_STATUS_PENDING"] = "CAMPAIGN_SHARING_STATUS_PENDING";
})(CampaignSharingStatus || (CampaignSharingStatus = {}));
export var CampaignSharingStatus_index;
(function (CampaignSharingStatus_index) {
    CampaignSharingStatus_index[CampaignSharingStatus_index["CAMPAIGN_SHARING_STATUS_UNSPECIFIED"] = 0] = "CAMPAIGN_SHARING_STATUS_UNSPECIFIED";
    CampaignSharingStatus_index[CampaignSharingStatus_index["CAMPAIGN_SHARING_STATUS_ACCEPTED"] = 1] = "CAMPAIGN_SHARING_STATUS_ACCEPTED";
    CampaignSharingStatus_index[CampaignSharingStatus_index["CAMPAIGN_SHARING_STATUS_DECLINED"] = 2] = "CAMPAIGN_SHARING_STATUS_DECLINED";
    CampaignSharingStatus_index[CampaignSharingStatus_index["CAMPAIGN_SHARING_STATUS_PENDING"] = 3] = "CAMPAIGN_SHARING_STATUS_PENDING";
})(CampaignSharingStatus_index || (CampaignSharingStatus_index = {}));
export var CampaignUsecase;
(function (CampaignUsecase) {
    CampaignUsecase["CAMPAIGN_USECASE_UNSPECIFIED"] = "CAMPAIGN_USECASE_UNSPECIFIED";
    CampaignUsecase["CAMPAIGN_USECASE_LOW_VOLUME_MIXED"] = "CAMPAIGN_USECASE_LOW_VOLUME_MIXED";
    CampaignUsecase["CAMPAIGN_USECASE_SOLE_PROPRIETOR"] = "CAMPAIGN_USECASE_SOLE_PROPRIETOR";
    CampaignUsecase["CAMPAIGN_USECASE_MIXED"] = "CAMPAIGN_USECASE_MIXED";
})(CampaignUsecase || (CampaignUsecase = {}));
export var CampaignUsecase_index;
(function (CampaignUsecase_index) {
    CampaignUsecase_index[CampaignUsecase_index["CAMPAIGN_USECASE_UNSPECIFIED"] = 0] = "CAMPAIGN_USECASE_UNSPECIFIED";
    CampaignUsecase_index[CampaignUsecase_index["CAMPAIGN_USECASE_LOW_VOLUME_MIXED"] = 1] = "CAMPAIGN_USECASE_LOW_VOLUME_MIXED";
    CampaignUsecase_index[CampaignUsecase_index["CAMPAIGN_USECASE_SOLE_PROPRIETOR"] = 2] = "CAMPAIGN_USECASE_SOLE_PROPRIETOR";
    CampaignUsecase_index[CampaignUsecase_index["CAMPAIGN_USECASE_MIXED"] = 3] = "CAMPAIGN_USECASE_MIXED";
})(CampaignUsecase_index || (CampaignUsecase_index = {}));
export var CampaignSubUsecase;
(function (CampaignSubUsecase) {
    CampaignSubUsecase["CAMPAIGN_SUB_USECASE_UNSPECIFIED"] = "CAMPAIGN_SUB_USECASE_UNSPECIFIED";
    CampaignSubUsecase["CAMPAIGN_SUB_USECASE_CUSTOMER_CARE"] = "CAMPAIGN_SUB_USECASE_CUSTOMER_CARE";
    CampaignSubUsecase["CAMPAIGN_SUB_USECASE_MARKETING"] = "CAMPAIGN_SUB_USECASE_MARKETING";
    CampaignSubUsecase["CAMPAIGN_SUB_USECASE_ACCOUNT_NOTIFICATION"] = "CAMPAIGN_SUB_USECASE_ACCOUNT_NOTIFICATION";
})(CampaignSubUsecase || (CampaignSubUsecase = {}));
export var CampaignSubUsecase_index;
(function (CampaignSubUsecase_index) {
    CampaignSubUsecase_index[CampaignSubUsecase_index["CAMPAIGN_SUB_USECASE_UNSPECIFIED"] = 0] = "CAMPAIGN_SUB_USECASE_UNSPECIFIED";
    CampaignSubUsecase_index[CampaignSubUsecase_index["CAMPAIGN_SUB_USECASE_CUSTOMER_CARE"] = 1] = "CAMPAIGN_SUB_USECASE_CUSTOMER_CARE";
    CampaignSubUsecase_index[CampaignSubUsecase_index["CAMPAIGN_SUB_USECASE_MARKETING"] = 2] = "CAMPAIGN_SUB_USECASE_MARKETING";
    CampaignSubUsecase_index[CampaignSubUsecase_index["CAMPAIGN_SUB_USECASE_ACCOUNT_NOTIFICATION"] = 3] = "CAMPAIGN_SUB_USECASE_ACCOUNT_NOTIFICATION";
})(CampaignSubUsecase_index || (CampaignSubUsecase_index = {}));
export var Country;
(function (Country) {
    Country["COUNTRY_UNSPECIFIED"] = "COUNTRY_UNSPECIFIED";
    Country["COUNTRY_US"] = "COUNTRY_US";
    Country["COUNTRY_CA"] = "COUNTRY_CA";
})(Country || (Country = {}));
export var Country_index;
(function (Country_index) {
    Country_index[Country_index["COUNTRY_UNSPECIFIED"] = 0] = "COUNTRY_UNSPECIFIED";
    Country_index[Country_index["COUNTRY_US"] = 1] = "COUNTRY_US";
    Country_index[Country_index["COUNTRY_CA"] = 2] = "COUNTRY_CA";
})(Country_index || (Country_index = {}));
export var TaxIDType;
(function (TaxIDType) {
    TaxIDType["TAX_ID_TYPE_UNSPECIFIED"] = "TAX_ID_TYPE_UNSPECIFIED";
    TaxIDType["TAX_ID_TYPE_EIN"] = "TAX_ID_TYPE_EIN";
    TaxIDType["TAX_ID_TYPE_CRA_BN"] = "TAX_ID_TYPE_CRA_BN";
})(TaxIDType || (TaxIDType = {}));
export var TaxIDType_index;
(function (TaxIDType_index) {
    TaxIDType_index[TaxIDType_index["TAX_ID_TYPE_UNSPECIFIED"] = 0] = "TAX_ID_TYPE_UNSPECIFIED";
    TaxIDType_index[TaxIDType_index["TAX_ID_TYPE_EIN"] = 1] = "TAX_ID_TYPE_EIN";
    TaxIDType_index[TaxIDType_index["TAX_ID_TYPE_CRA_BN"] = 2] = "TAX_ID_TYPE_CRA_BN";
})(TaxIDType_index || (TaxIDType_index = {}));
export var EntityType;
(function (EntityType) {
    EntityType["ENTITY_TYPE_UNSPECIFIED"] = "ENTITY_TYPE_UNSPECIFIED";
    EntityType["ENTITY_TYPE_PRIVATE_PROFIT"] = "ENTITY_TYPE_PRIVATE_PROFIT";
    EntityType["ENTITY_TYPE_PUBLIC_PROFIT"] = "ENTITY_TYPE_PUBLIC_PROFIT";
    EntityType["ENTITY_TYPE_NON_PROFIT"] = "ENTITY_TYPE_NON_PROFIT";
    EntityType["ENTITY_TYPE_GOVERNMENT"] = "ENTITY_TYPE_GOVERNMENT";
    EntityType["ENTITY_TYPE_SOLE_PROPRIETOR"] = "ENTITY_TYPE_SOLE_PROPRIETOR";
})(EntityType || (EntityType = {}));
export var EntityType_index;
(function (EntityType_index) {
    EntityType_index[EntityType_index["ENTITY_TYPE_UNSPECIFIED"] = 0] = "ENTITY_TYPE_UNSPECIFIED";
    EntityType_index[EntityType_index["ENTITY_TYPE_PRIVATE_PROFIT"] = 1] = "ENTITY_TYPE_PRIVATE_PROFIT";
    EntityType_index[EntityType_index["ENTITY_TYPE_PUBLIC_PROFIT"] = 2] = "ENTITY_TYPE_PUBLIC_PROFIT";
    EntityType_index[EntityType_index["ENTITY_TYPE_NON_PROFIT"] = 3] = "ENTITY_TYPE_NON_PROFIT";
    EntityType_index[EntityType_index["ENTITY_TYPE_GOVERNMENT"] = 4] = "ENTITY_TYPE_GOVERNMENT";
    EntityType_index[EntityType_index["ENTITY_TYPE_SOLE_PROPRIETOR"] = 5] = "ENTITY_TYPE_SOLE_PROPRIETOR";
})(EntityType_index || (EntityType_index = {}));
export var AltBusinessType;
(function (AltBusinessType) {
    AltBusinessType["ALT_BUSINESS_TYPE_UNSPECIFIED"] = "ALT_BUSINESS_TYPE_UNSPECIFIED";
    AltBusinessType["ALT_BUSINESS_TYPE_DUNS"] = "ALT_BUSINESS_TYPE_DUNS";
    AltBusinessType["ALT_BUSINESS_TYPE_LEI"] = "ALT_BUSINESS_TYPE_LEI";
    AltBusinessType["ALT_BUSINESS_TYPE_GIIN"] = "ALT_BUSINESS_TYPE_GIIN";
})(AltBusinessType || (AltBusinessType = {}));
export var AltBusinessType_index;
(function (AltBusinessType_index) {
    AltBusinessType_index[AltBusinessType_index["ALT_BUSINESS_TYPE_UNSPECIFIED"] = 0] = "ALT_BUSINESS_TYPE_UNSPECIFIED";
    AltBusinessType_index[AltBusinessType_index["ALT_BUSINESS_TYPE_DUNS"] = 1] = "ALT_BUSINESS_TYPE_DUNS";
    AltBusinessType_index[AltBusinessType_index["ALT_BUSINESS_TYPE_LEI"] = 2] = "ALT_BUSINESS_TYPE_LEI";
    AltBusinessType_index[AltBusinessType_index["ALT_BUSINESS_TYPE_GIIN"] = 3] = "ALT_BUSINESS_TYPE_GIIN";
})(AltBusinessType_index || (AltBusinessType_index = {}));
export var BrandRelationship;
(function (BrandRelationship) {
    BrandRelationship["BRAND_RELATIONSHIP_UNSPECIFIED"] = "BRAND_RELATIONSHIP_UNSPECIFIED";
    BrandRelationship["BRAND_RELATIONSHIP_BASIC_ACCOUNT"] = "BRAND_RELATIONSHIP_BASIC_ACCOUNT";
    BrandRelationship["BRAND_RELATIONSHIP_SMALL_ACCOUNT"] = "BRAND_RELATIONSHIP_SMALL_ACCOUNT";
    BrandRelationship["BRAND_RELATIONSHIP_MEDIUM_ACCOUNT"] = "BRAND_RELATIONSHIP_MEDIUM_ACCOUNT";
    BrandRelationship["BRAND_RELATIONSHIP_LARGE_ACCOUNT"] = "BRAND_RELATIONSHIP_LARGE_ACCOUNT";
    BrandRelationship["BRAND_RELATIONSHIP_KEY_ACCOUNT"] = "BRAND_RELATIONSHIP_KEY_ACCOUNT";
})(BrandRelationship || (BrandRelationship = {}));
export var BrandRelationship_index;
(function (BrandRelationship_index) {
    BrandRelationship_index[BrandRelationship_index["BRAND_RELATIONSHIP_UNSPECIFIED"] = 0] = "BRAND_RELATIONSHIP_UNSPECIFIED";
    BrandRelationship_index[BrandRelationship_index["BRAND_RELATIONSHIP_BASIC_ACCOUNT"] = 1] = "BRAND_RELATIONSHIP_BASIC_ACCOUNT";
    BrandRelationship_index[BrandRelationship_index["BRAND_RELATIONSHIP_SMALL_ACCOUNT"] = 2] = "BRAND_RELATIONSHIP_SMALL_ACCOUNT";
    BrandRelationship_index[BrandRelationship_index["BRAND_RELATIONSHIP_MEDIUM_ACCOUNT"] = 3] = "BRAND_RELATIONSHIP_MEDIUM_ACCOUNT";
    BrandRelationship_index[BrandRelationship_index["BRAND_RELATIONSHIP_LARGE_ACCOUNT"] = 4] = "BRAND_RELATIONSHIP_LARGE_ACCOUNT";
    BrandRelationship_index[BrandRelationship_index["BRAND_RELATIONSHIP_KEY_ACCOUNT"] = 5] = "BRAND_RELATIONSHIP_KEY_ACCOUNT";
})(BrandRelationship_index || (BrandRelationship_index = {}));
export var TCRVertical;
(function (TCRVertical) {
    TCRVertical["TCR_VERTICAL_UNSPECIFIED"] = "TCR_VERTICAL_UNSPECIFIED";
    TCRVertical["TCR_VERTICAL_PROFESSIONAL"] = "TCR_VERTICAL_PROFESSIONAL";
    TCRVertical["TCR_VERTICAL_REAL_ESTATE"] = "TCR_VERTICAL_REAL_ESTATE";
    TCRVertical["TCR_VERTICAL_HEALTHCARE"] = "TCR_VERTICAL_HEALTHCARE";
    TCRVertical["TCR_VERTICAL_HUMAN_RESOURCES"] = "TCR_VERTICAL_HUMAN_RESOURCES";
    TCRVertical["TCR_VERTICAL_ENERGY"] = "TCR_VERTICAL_ENERGY";
    TCRVertical["TCR_VERTICAL_ENTERTAINMENT"] = "TCR_VERTICAL_ENTERTAINMENT";
    TCRVertical["TCR_VERTICAL_RETAIL"] = "TCR_VERTICAL_RETAIL";
    TCRVertical["TCR_VERTICAL_TRANSPORTATION"] = "TCR_VERTICAL_TRANSPORTATION";
    TCRVertical["TCR_VERTICAL_AGRICULTURE"] = "TCR_VERTICAL_AGRICULTURE";
    TCRVertical["TCR_VERTICAL_INSURANCE"] = "TCR_VERTICAL_INSURANCE";
    TCRVertical["TCR_VERTICAL_POSTAL"] = "TCR_VERTICAL_POSTAL";
    TCRVertical["TCR_VERTICAL_EDUCATION"] = "TCR_VERTICAL_EDUCATION";
    TCRVertical["TCR_VERTICAL_HOSPITALITY"] = "TCR_VERTICAL_HOSPITALITY";
    TCRVertical["TCR_VERTICAL_FINANCIAL"] = "TCR_VERTICAL_FINANCIAL";
    TCRVertical["TCR_VERTICAL_POLITICAL"] = "TCR_VERTICAL_POLITICAL";
    TCRVertical["TCR_VERTICAL_GAMBLING"] = "TCR_VERTICAL_GAMBLING";
    TCRVertical["TCR_VERTICAL_LEGAL"] = "TCR_VERTICAL_LEGAL";
    TCRVertical["TCR_VERTICAL_CONSTRUCTION"] = "TCR_VERTICAL_CONSTRUCTION";
    TCRVertical["TCR_VERTICAL_NGO"] = "TCR_VERTICAL_NGO";
    TCRVertical["TCR_VERTICAL_MANUFACTURING"] = "TCR_VERTICAL_MANUFACTURING";
    TCRVertical["TCR_VERTICAL_GOVERNMENT"] = "TCR_VERTICAL_GOVERNMENT";
    TCRVertical["TCR_VERTICAL_TECHNOLOGY"] = "TCR_VERTICAL_TECHNOLOGY";
    TCRVertical["TCR_VERTICAL_COMMUNICATION"] = "TCR_VERTICAL_COMMUNICATION";
})(TCRVertical || (TCRVertical = {}));
export var TCRVertical_index;
(function (TCRVertical_index) {
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_UNSPECIFIED"] = 0] = "TCR_VERTICAL_UNSPECIFIED";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_PROFESSIONAL"] = 1] = "TCR_VERTICAL_PROFESSIONAL";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_REAL_ESTATE"] = 2] = "TCR_VERTICAL_REAL_ESTATE";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_HEALTHCARE"] = 3] = "TCR_VERTICAL_HEALTHCARE";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_HUMAN_RESOURCES"] = 4] = "TCR_VERTICAL_HUMAN_RESOURCES";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_ENERGY"] = 5] = "TCR_VERTICAL_ENERGY";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_ENTERTAINMENT"] = 6] = "TCR_VERTICAL_ENTERTAINMENT";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_RETAIL"] = 7] = "TCR_VERTICAL_RETAIL";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_TRANSPORTATION"] = 8] = "TCR_VERTICAL_TRANSPORTATION";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_AGRICULTURE"] = 9] = "TCR_VERTICAL_AGRICULTURE";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_INSURANCE"] = 10] = "TCR_VERTICAL_INSURANCE";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_POSTAL"] = 11] = "TCR_VERTICAL_POSTAL";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_EDUCATION"] = 12] = "TCR_VERTICAL_EDUCATION";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_HOSPITALITY"] = 13] = "TCR_VERTICAL_HOSPITALITY";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_FINANCIAL"] = 14] = "TCR_VERTICAL_FINANCIAL";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_POLITICAL"] = 15] = "TCR_VERTICAL_POLITICAL";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_GAMBLING"] = 16] = "TCR_VERTICAL_GAMBLING";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_LEGAL"] = 17] = "TCR_VERTICAL_LEGAL";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_CONSTRUCTION"] = 18] = "TCR_VERTICAL_CONSTRUCTION";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_NGO"] = 19] = "TCR_VERTICAL_NGO";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_MANUFACTURING"] = 20] = "TCR_VERTICAL_MANUFACTURING";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_GOVERNMENT"] = 21] = "TCR_VERTICAL_GOVERNMENT";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_TECHNOLOGY"] = 22] = "TCR_VERTICAL_TECHNOLOGY";
    TCRVertical_index[TCRVertical_index["TCR_VERTICAL_COMMUNICATION"] = 23] = "TCR_VERTICAL_COMMUNICATION";
})(TCRVertical_index || (TCRVertical_index = {}));
export var TCRCNP;
(function (TCRCNP) {
    TCRCNP["TCR_CNP_UNSPECIFIED"] = "TCR_CNP_UNSPECIFIED";
    TCRCNP["TCR_CNP_BANDWIDTH"] = "TCR_CNP_BANDWIDTH";
    TCRCNP["TCR_CNP_TELNYX"] = "TCR_CNP_TELNYX";
    TCRCNP["TCR_CNP_TWILIO"] = "TCR_CNP_TWILIO";
    TCRCNP["TCR_CNP_FLOWROUTE"] = "TCR_CNP_FLOWROUTE";
    TCRCNP["TCR_CNP_WEAVE_MOCK"] = "TCR_CNP_WEAVE_MOCK";
})(TCRCNP || (TCRCNP = {}));
export var TCRCNP_index;
(function (TCRCNP_index) {
    TCRCNP_index[TCRCNP_index["TCR_CNP_UNSPECIFIED"] = 0] = "TCR_CNP_UNSPECIFIED";
    TCRCNP_index[TCRCNP_index["TCR_CNP_BANDWIDTH"] = 1] = "TCR_CNP_BANDWIDTH";
    TCRCNP_index[TCRCNP_index["TCR_CNP_TELNYX"] = 2] = "TCR_CNP_TELNYX";
    TCRCNP_index[TCRCNP_index["TCR_CNP_TWILIO"] = 3] = "TCR_CNP_TWILIO";
    TCRCNP_index[TCRCNP_index["TCR_CNP_FLOWROUTE"] = 4] = "TCR_CNP_FLOWROUTE";
    TCRCNP_index[TCRCNP_index["TCR_CNP_WEAVE_MOCK"] = 5] = "TCR_CNP_WEAVE_MOCK";
})(TCRCNP_index || (TCRCNP_index = {}));
export var TCRBrandIdentityStatus;
(function (TCRBrandIdentityStatus) {
    TCRBrandIdentityStatus["TCR_BRAND_IDENTITY_STATUS_UNSPECIFIED"] = "TCR_BRAND_IDENTITY_STATUS_UNSPECIFIED";
    TCRBrandIdentityStatus["TCR_BRAND_IDENTITY_STATUS_SELF_DECLARED"] = "TCR_BRAND_IDENTITY_STATUS_SELF_DECLARED";
    TCRBrandIdentityStatus["TCR_BRAND_IDENTITY_STATUS_UNVERIFIED"] = "TCR_BRAND_IDENTITY_STATUS_UNVERIFIED";
    TCRBrandIdentityStatus["TCR_BRAND_IDENTITY_STATUS_VERIFIED"] = "TCR_BRAND_IDENTITY_STATUS_VERIFIED";
    TCRBrandIdentityStatus["TCR_BRAND_IDENTITY_STATUS_VETTED_VERIFIED"] = "TCR_BRAND_IDENTITY_STATUS_VETTED_VERIFIED";
})(TCRBrandIdentityStatus || (TCRBrandIdentityStatus = {}));
export var TCRBrandIdentityStatus_index;
(function (TCRBrandIdentityStatus_index) {
    TCRBrandIdentityStatus_index[TCRBrandIdentityStatus_index["TCR_BRAND_IDENTITY_STATUS_UNSPECIFIED"] = 0] = "TCR_BRAND_IDENTITY_STATUS_UNSPECIFIED";
    TCRBrandIdentityStatus_index[TCRBrandIdentityStatus_index["TCR_BRAND_IDENTITY_STATUS_SELF_DECLARED"] = 1] = "TCR_BRAND_IDENTITY_STATUS_SELF_DECLARED";
    TCRBrandIdentityStatus_index[TCRBrandIdentityStatus_index["TCR_BRAND_IDENTITY_STATUS_UNVERIFIED"] = 2] = "TCR_BRAND_IDENTITY_STATUS_UNVERIFIED";
    TCRBrandIdentityStatus_index[TCRBrandIdentityStatus_index["TCR_BRAND_IDENTITY_STATUS_VERIFIED"] = 3] = "TCR_BRAND_IDENTITY_STATUS_VERIFIED";
    TCRBrandIdentityStatus_index[TCRBrandIdentityStatus_index["TCR_BRAND_IDENTITY_STATUS_VETTED_VERIFIED"] = 4] = "TCR_BRAND_IDENTITY_STATUS_VETTED_VERIFIED";
})(TCRBrandIdentityStatus_index || (TCRBrandIdentityStatus_index = {}));
export var WeaveLocationType;
(function (WeaveLocationType) {
    WeaveLocationType["WEAVE_LOCATION_TYPE_UNSPECIFIED"] = "WEAVE_LOCATION_TYPE_UNSPECIFIED";
    WeaveLocationType["WEAVE_LOCATION_TYPE_REGULAR"] = "WEAVE_LOCATION_TYPE_REGULAR";
    WeaveLocationType["WEAVE_LOCATION_TYPE_DEMO"] = "WEAVE_LOCATION_TYPE_DEMO";
    WeaveLocationType["WEAVE_LOCATION_TYPE_DEV"] = "WEAVE_LOCATION_TYPE_DEV";
    WeaveLocationType["WEAVE_LOCATION_TYPE_TEST"] = "WEAVE_LOCATION_TYPE_TEST";
})(WeaveLocationType || (WeaveLocationType = {}));
export var WeaveLocationType_index;
(function (WeaveLocationType_index) {
    WeaveLocationType_index[WeaveLocationType_index["WEAVE_LOCATION_TYPE_UNSPECIFIED"] = 0] = "WEAVE_LOCATION_TYPE_UNSPECIFIED";
    WeaveLocationType_index[WeaveLocationType_index["WEAVE_LOCATION_TYPE_REGULAR"] = 1] = "WEAVE_LOCATION_TYPE_REGULAR";
    WeaveLocationType_index[WeaveLocationType_index["WEAVE_LOCATION_TYPE_DEMO"] = 2] = "WEAVE_LOCATION_TYPE_DEMO";
    WeaveLocationType_index[WeaveLocationType_index["WEAVE_LOCATION_TYPE_DEV"] = 3] = "WEAVE_LOCATION_TYPE_DEV";
    WeaveLocationType_index[WeaveLocationType_index["WEAVE_LOCATION_TYPE_TEST"] = 4] = "WEAVE_LOCATION_TYPE_TEST";
})(WeaveLocationType_index || (WeaveLocationType_index = {}));
/**
 * Custom Weave audit event types.
 * Expected to have more event types added in the future.
 */
export var TCRAuditEventType;
(function (TCRAuditEventType) {
    TCRAuditEventType["TCR_AUDIT_EVENT_TYPE_UNSPECIFIED"] = "TCR_AUDIT_EVENT_TYPE_UNSPECIFIED";
    TCRAuditEventType["TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_SUCCESS"] = "TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_SUCCESS";
    TCRAuditEventType["TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_FAILURE"] = "TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_FAILURE";
})(TCRAuditEventType || (TCRAuditEventType = {}));
export var TCRAuditEventType_index;
(function (TCRAuditEventType_index) {
    TCRAuditEventType_index[TCRAuditEventType_index["TCR_AUDIT_EVENT_TYPE_UNSPECIFIED"] = 0] = "TCR_AUDIT_EVENT_TYPE_UNSPECIFIED";
    TCRAuditEventType_index[TCRAuditEventType_index["TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_SUCCESS"] = 1] = "TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_SUCCESS";
    TCRAuditEventType_index[TCRAuditEventType_index["TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_FAILURE"] = 2] = "TCR_AUDIT_EVENT_TYPE_BRAND_VERIFICATION_FAILURE";
})(TCRAuditEventType_index || (TCRAuditEventType_index = {}));
/**
 * Custom Weave statuses. These are an abstraction that identifies
 * whether or not a phone number is properly registered to a TCR campaign,
 * with fine-grained explanations of overall 10DLC state for when it isn't.
 */
export var PhoneRegistrationStatus;
(function (PhoneRegistrationStatus) {
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_UNSPECIFIED"] = "PHONE_REGISTRATION_STATUS_UNSPECIFIED";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_REGISTERED"] = "PHONE_REGISTRATION_STATUS_REGISTERED";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_REGISTERABLE_QUICKLY"] = "PHONE_REGISTRATION_STATUS_REGISTERABLE_QUICKLY";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_REGISTERABLE_SLOWLY"] = "PHONE_REGISTRATION_STATUS_REGISTERABLE_SLOWLY";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_UNREGISTERABLE"] = "PHONE_REGISTRATION_STATUS_UNREGISTERABLE";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_PENDING"] = "PHONE_REGISTRATION_STATUS_PENDING";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_FAILED"] = "PHONE_REGISTRATION_STATUS_FAILED";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_REJECTED"] = "PHONE_REGISTRATION_STATUS_REJECTED";
    PhoneRegistrationStatus["PHONE_REGISTRATION_STATUS_IN_PROGRESS"] = "PHONE_REGISTRATION_STATUS_IN_PROGRESS";
})(PhoneRegistrationStatus || (PhoneRegistrationStatus = {}));
export var PhoneRegistrationStatus_index;
(function (PhoneRegistrationStatus_index) {
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_UNSPECIFIED"] = 0] = "PHONE_REGISTRATION_STATUS_UNSPECIFIED";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_REGISTERED"] = 1] = "PHONE_REGISTRATION_STATUS_REGISTERED";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_REGISTERABLE_QUICKLY"] = 2] = "PHONE_REGISTRATION_STATUS_REGISTERABLE_QUICKLY";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_REGISTERABLE_SLOWLY"] = 3] = "PHONE_REGISTRATION_STATUS_REGISTERABLE_SLOWLY";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_UNREGISTERABLE"] = 4] = "PHONE_REGISTRATION_STATUS_UNREGISTERABLE";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_PENDING"] = 5] = "PHONE_REGISTRATION_STATUS_PENDING";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_FAILED"] = 6] = "PHONE_REGISTRATION_STATUS_FAILED";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_REJECTED"] = 7] = "PHONE_REGISTRATION_STATUS_REJECTED";
    PhoneRegistrationStatus_index[PhoneRegistrationStatus_index["PHONE_REGISTRATION_STATUS_IN_PROGRESS"] = 8] = "PHONE_REGISTRATION_STATUS_IN_PROGRESS";
})(PhoneRegistrationStatus_index || (PhoneRegistrationStatus_index = {}));
/**
 * Custom Weave statuses. These track campaign approval, downstream
 * of providers like Bandwidth/Telnyx.
 */
export var SecondaryDCAStatus;
(function (SecondaryDCAStatus) {
    SecondaryDCAStatus["SECONDARY_DCA_STATUS_UNSPECIFIED"] = "SECONDARY_DCA_STATUS_UNSPECIFIED";
    SecondaryDCAStatus["SECONDARY_DCA_STATUS_ACCEPTED"] = "SECONDARY_DCA_STATUS_ACCEPTED";
    SecondaryDCAStatus["SECONDARY_DCA_STATUS_DECLINED"] = "SECONDARY_DCA_STATUS_DECLINED";
    SecondaryDCAStatus["SECONDARY_DCA_STATUS_PENDING"] = "SECONDARY_DCA_STATUS_PENDING";
})(SecondaryDCAStatus || (SecondaryDCAStatus = {}));
export var SecondaryDCAStatus_index;
(function (SecondaryDCAStatus_index) {
    SecondaryDCAStatus_index[SecondaryDCAStatus_index["SECONDARY_DCA_STATUS_UNSPECIFIED"] = 0] = "SECONDARY_DCA_STATUS_UNSPECIFIED";
    SecondaryDCAStatus_index[SecondaryDCAStatus_index["SECONDARY_DCA_STATUS_ACCEPTED"] = 1] = "SECONDARY_DCA_STATUS_ACCEPTED";
    SecondaryDCAStatus_index[SecondaryDCAStatus_index["SECONDARY_DCA_STATUS_DECLINED"] = 2] = "SECONDARY_DCA_STATUS_DECLINED";
    SecondaryDCAStatus_index[SecondaryDCAStatus_index["SECONDARY_DCA_STATUS_PENDING"] = 3] = "SECONDARY_DCA_STATUS_PENDING";
})(SecondaryDCAStatus_index || (SecondaryDCAStatus_index = {}));
